export default __webpack_public_path__ + "static/char-s-sp02-en-92d271edfa7c6cb077ccf4dc319d4b62.webp";